<section class="progressive_initiatives_sec" *ngIf="initiativesSettings">
  <div class="initiatives_top"></div>
  <div class="initiatives_left"></div>
  <div class="initiatives_right"></div>
  <div class="wrapper">
    <div class="initiatives_banner">
      <div class="initiatives_heading_banner">
        <img src="../../../../../assets/images/progressive_initiatives.png" alt="progressive_initiatives">
        <div class="banner_container">
          <div class="content">
            <h2>Progressive Initiatives</h2>
          </div>
        </div>
        <div class="banner_overlay"></div>
      </div>
    </div>
    <div class="initiatives_box_row">
      <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
        <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
          fxFlexFill>
          <div class="swiper-container" [swiper]="initiativesConfig" (indexChange)="onIndexChange($event)">
            <div class="swiper-wrapper">
              <!-- slide -->
              <div class="swiper-slide" *ngFor="let singleSection of sections">
                <div class="initiatives_box">
                  <img [src]="initiativesSettings[singleSection.id].image.url">
                  <div class="initiatives_content">
                    <h3 *ngIf="lang === 'en'">{{initiativesSettings[singleSection.id].en_title}} </h3>
                    <h3 *ngIf="lang === 'te'">{{initiativesSettings[singleSection.id].te_title}} </h3>
                    <!--<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>-->
                    <button class="btn btn-sm read-btn" mat-button [routerLink]="['/initiatives_settings', singleSection.id]" queryParamsHandling="merge" >Read More</button>
                  </div>
                </div>
              </div>

            </div>
            <div class="navigations">
              <div class="swiper-button-prev initiatives-button-prev">
                <img src="../../../../../assets/images/icons/chervon_left.svg" alt="">
              </div>
              <div class="swiper-button-next initiatives-button-next">
                <img src="../../../../../assets/images/icons/chervon_right.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
